const indexInit = {
    
}
const address = (state = indexInit, action) => {
    switch (action.type) {
      case "TICKET_LST":
        return Object.assign({}, state, {
          ...action
        });
      default:
        return state;
    }
}

export default address